import { axios } from '@/lib/axios';

import { AuthUser } from '../types';

export type RegisterCredentials = {
  email: string;
  confirmSuccessUrl: string;
  isTermsAgreed: boolean;
};

export const register = async (
  data: RegisterCredentials
): Promise<AuthUser> => {
  return axios.post('/api/v1/auth', data);
};
